(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundler"] && !window.DesignMode) return;
  try {
    
  const { strings: locales } = window.theme;

  const stepCount = document.querySelector('.bundler__wrapper').dataset.stepCount;
  let currentStep = 1;
  let bundledProducts = Array.from({ length: stepCount - 1 }, () => []); // Initialize empty arrays for each step to make it easy to push variant ids
  let stepProductQuantity = document.querySelector(`.js-step-${currentStep}`).dataset.stepQuantity;
  let canProgress = false;
  let cartPrice = 0;

  // Mostly shows and hides the elements from each step
  function setStep(step) {
    // Step progress bar
    document.querySelectorAll('.active-progress-step').forEach((element) => {
      element.classList.remove('active-progress-step');
    });

    // Create an array of selectors for the active step progress elements
    const progressStepSelectors = [];
    for (let i = 1; i <= stepCount + 1; i++) {
      if (i <= step) {
        progressStepSelectors.push(`.js-progress-step-${i}`)
      }
    }

    document.querySelectorAll(progressStepSelectors).forEach((element) => {
      element.classList.add('active-progress-step');
    });

    // Product selector
    document.querySelectorAll(['.bundler__products', '.bundler__bundle']).forEach((element) => {
      element.classList.remove('active-step');
    });

    document.querySelectorAll(`.js-step-${step}`).forEach((element) => {
      element.classList.add('active-step');

      // Update how many products are required this step
      if (element.dataset.stepQuantity) {
        stepProductQuantity = element.dataset.stepQuantity;
      }
    });

    // Bundle review step
    const finalStep = document.querySelector('.bundler__final');
    const atcButton = document.querySelector('.bundler__atc');

    if (currentStep == stepCount) {
      finalStep.classList.add('active-step');
      atcButton.querySelector('.price').innerHTML = ` • ${window.theme.moneyFormatWithCurrency.replace(window.theme.moneyFormat, themeVendor.themeCurrency.formatMoney(cartPrice, window.theme.moneyFormat))}`;
      atcButton.classList.remove('hide');
    } else {
      finalStep.classList.remove('active-step');
      atcButton.classList.add('hide');
    }

    // Bundler content add-ons layout
    document.querySelector('.bundler__content').classList.toggle('no-limit-content', document.querySelector(`.js-step-${step}.no-limit`) || currentStep == stepCount);

    // Update next button state on step change
    nextState();
  }

  // Mobile add to bundle button behaviour
  const overlays = document.querySelectorAll('.bundler__button-overlay');
  overlays.forEach((overlay) => {
    overlay.addEventListener('click', () => {
      overlays.forEach((element) => {
        element.classList.toggle('hide-overlay', element === overlay);
        element.closest('.bundler__add-buttons').querySelectorAll('.bundler__add-button').forEach((button) => {
          button.classList.toggle('clickable', element === overlay);
        });
      });
    });
  });

  // Step progression buttons functionality + state
  const nextButton = document.querySelector('.bundler__next-step');

  nextButton.addEventListener('click', () => {
    if (currentStep + 1 <= stepCount && canProgress) {
      currentStep += 1;
      setStep(currentStep);

      if (currentStep + 1 > stepCount) {
        nextButton.disabled = true;
        nextButton.classList.add('hide');
      }
      if (currentStep - 1 >= 1) {
        prevButton.disabled = false;
        prevButton.classList.remove('hide');
      }

      document.querySelector('.bundler__step-progress').scrollIntoView(true);
    }
  });

  const prevButton = document.querySelector('.bundler__prev-step');

  prevButton.addEventListener('click', () => {
    if (currentStep - 1 >= 1) {
      currentStep = currentStep - 1;
      setStep(currentStep);

      if (currentStep + 1 <= stepCount) {
        nextButton.disabled = false;
        nextButton.classList.remove('hide');
      }
      if (currentStep - 1 < 1) {
        prevButton.disabled = true;
        prevButton.classList.add('hide');
      }

      document.querySelector('.bundler__step-progress').scrollIntoView(true);
    }
  });

  // Remove from bundle
  function removeProduct(id, step) {
    const index = bundledProducts[step].indexOf(id);
    if (index > -1) {
      bundledProducts[step].splice(index, 1);
    }
  }

  // Add to bundle
  document.querySelectorAll('.bundler__add-button').forEach((element) => {
    const buttonText = element.innerHTML;

    // Add button behaviour
    element.addEventListener('click', () => {
      if (bundledProducts[currentStep - 1].length < stepProductQuantity || stepProductQuantity == 0) {
        const productTile = element.closest('.bundler__product-tile');
        bundledProducts[currentStep - 1].push(element.dataset.variantId);

        cartPrice += parseFloat(element.dataset.variantPrice.replace(/[^0-9]+/g,""));

        // styling
        element.classList.add('added');

        if (stepProductQuantity > 0) {
          const placeholderElement = document.querySelector(`.js-step-${currentStep}-placeholder-${bundledProducts[currentStep - 1].length}`);
          placeholderElement.classList.add('hidden');
        }

        document.querySelectorAll('.hide-overlay').forEach((overlay) => {
          overlay.classList.toggle('hide-overlay', element.closest('.bundler__add-buttons') === overlay.closest('.bundler__add-buttons'));
          overlay.closest('.bundler__add-buttons').querySelectorAll('.bundler__add-button').forEach((button) => {
            button.classList.toggle('clickable', element.closest('.bundler__add-buttons') === overlay.closest('.bundler__add-buttons'));
          });
        });

        // clone tile
        const stepClone = productTile.cloneNode(true);

        stepClone.querySelectorAll('.bundler-product-tile__image').forEach((image) => {
          image.classList.remove('active-image');

          if (image.dataset.variantImage == element.dataset.variantId) {
            image.classList.add('active-image');
          }
        });

        stepClone.dataset.variantId = element.dataset.variantId;
        stepClone.querySelector('.bundler__add-buttons').remove();

        if (!element.dataset.singleVariant) {
          stepClone.querySelector('.product__grid__title').innerHTML += ` - ${buttonText}`;
          stepClone.querySelector('.price').innerHTML = `${element.dataset.variantPrice}`;
        }

        // Add tile clone to final bundle step
        const bundleClone = document.querySelector('.js-bundle-content').appendChild(stepClone.cloneNode(true));

        // Create step tile w/ remove button functionality
        const removeButton = document.createElement('button');
        removeButton.innerHTML = locales.remove;
        removeButton.type = 'button';
        removeButton.classList.add('bundler__remove-button', 'bundler__button--outline')

        const bundleRemoveButton = removeButton.cloneNode(true);

        // Remove button behaviour
        [removeButton, bundleRemoveButton].forEach((button) => {
          button.addEventListener('click', () => {
            removeProduct(stepClone.dataset.variantId, stepClone.dataset.productStep - 1);

            cartPrice -= parseFloat(element.dataset.variantPrice.replace(/[^0-9]+/g,""));

            document.querySelectorAll('.js-bundle-placeholder').forEach((stepContent) => {
              if (!stepContent.classList.contains(`js-bundle-placeholder-${currentStep}`)) {
                stepContent.querySelector(`[data-variant-id='${stepClone.dataset.variantId}']`)?.remove();
              }
            });

            stepClone.remove();
            bundleClone.remove();

            if (stepProductQuantity > 0) {
              const placeholderElement = document.querySelector(`.js-step-${currentStep}-placeholder-${bundledProducts[currentStep - 1].length + 1}`);
              placeholderElement.classList.remove('hidden');
            }

            document.querySelector('.bundler__atc').querySelector('.price').innerHTML = ` • ${window.theme.moneyFormatWithCurrency.replace(window.theme.moneyFormat, themeVendor.themeCurrency.formatMoney(cartPrice, window.theme.moneyFormat))}`;

            // Update next button state on remove
            nextState();
          });
        })

        document.querySelectorAll('.js-bundle-placeholder').forEach((stepContent) => {
          if (!stepContent.classList.contains(`js-bundle-placeholder-${currentStep}`)) {
            const tempClone = stepClone.cloneNode(true);
            stepContent.appendChild(tempClone);
          }
        });

        stepClone.appendChild(removeButton);

        // add remove button to final bundle step tile if the step has no quantity requirement
        if (productTile.dataset.removable) {
          bundleClone.appendChild(bundleRemoveButton);
        }

        document.querySelector(`.js-bundle-content-${currentStep}`).appendChild(stepClone);

        // Update next button state on add
        nextState();

        element.innerHTML = locales.added;

        setTimeout(() => {
          element.classList.remove('added');
          element.innerHTML = buttonText;

          const buttonContainer = element.closest('.bundler__add-buttons');

          buttonContainer.querySelector('.bundler__button-overlay')?.classList.remove('hide-overlay');

          buttonContainer.querySelectorAll('.bundler__add-button').forEach((button) => {
            button.classList.remove('clickable');
          });
        }, 2000);
      }
    });
  })

  // Set next button state according to number of required products this step
  function nextState() {
    const nextStepButton = document.querySelector('.bundler__next-step');
    if (currentStep != stepCount) {
      nextStepButton.classList.remove('hide');
      if (bundledProducts[currentStep - 1].length == stepProductQuantity || stepProductQuantity == 0) {
        canProgress = true;
        nextStepButton.disabled = false;

        if (currentStep == stepCount - 1) {
          nextStepButton.innerHTML = locales.reviewOrder;
        } else {
          nextStepButton.innerHTML = locales.nextStep;
        }
      } else {
        canProgress = false;
        nextStepButton.disabled = true;
        nextStepButton.innerHTML = locales.makeSelections;
      }
    } else {
      nextStepButton.classList.add('hide');
    }
  }

  // Add to cart
  document.querySelector('.bundler__atc').addEventListener('click', () => {
    let formData = {
      items: bundledProducts.flat().map(id => ({
        id: id,
        quantity: 1
      }))
    };

    addBundleToCart(formData).then(() => {
      window.location.href = window.theme.routes.cart;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  function addBundleToCart(formData) {
    return fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  // Initialize section
  setStep(currentStep);
  document.querySelector('.bundler').classList.remove('hidden');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const atcElement = document.querySelector('.btn--add-to-cart');
  const originalPrice = atcElement.querySelector('span[data-button-price]').innerHTML;

  function setPrice() {
    const ogElement = document.querySelector('og-offer');

    if (!!ogElement.subscribed && document.querySelector('span[data-button-price]')) {
      const newPrice = parseFloat(document.querySelector('og-offer og-price[subscription]').shadowRoot.textContent.trim().replace(/[^0-9]+/g,""));
      const formattedPrice = themeVendor.themeCurrency.formatMoney(newPrice, window.theme.moneyFormatWithCurrency);
      document.querySelector('span[data-button-price]').innerHTML =  formattedPrice;
    } else {
      document.querySelector('span[data-button-price]').innerHTML =  originalPrice;
    }
  }

  document.querySelectorAll('.subscription-option').forEach((element) => {
    element.addEventListener('click', () => {
      setPrice();
    });
  });

  new MutationObserver((mutations, observer) => {
    // shadow root makes it hard to detect changes in DOM
    if (!!document.querySelector('og-offer og-price[subscription]')?.shadowRoot.textContent.trim()) {
      setPrice();
      observer.disconnect();
    }
  }).observe(document.body, {
    subtree: true,
    childList: true,
  });

  // Product badge logic
  const { badges: { badges }, product: { tags } } = window.theme;
  
  badgeImage = badges.find((badge) => tags.includes(badge.product_tag)).image;
  
  if (badgeImage) {
    const badgeParent = document.querySelector('[data-pdp-badge]');
    if (badgeParent && badges.length > 0) {
      badgeElement = document.createElement('img');
      badgeElement.src = badgeImage;

      badgeParent.appendChild(badgeElement);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-results"] && !window.DesignMode) return;
  try {
    
  if (document.querySelector('[data-results-section]')) {
    const imageCount = document.querySelector('.results-section__carousel').dataset.imageCount;
    let currentImage = 0;
  
    document.querySelector('.results-section__next').addEventListener('click', () => {
      currentImage = currentImage + 1 >= imageCount ? 0 : currentImage + 1;
  
      document.querySelectorAll('.results-section__image').forEach((image) => {
        image.classList.toggle('active-image', image.dataset.imageId == currentImage);
      });
    });
  
    function openModal() {
      const modal = document.querySelector('.results-section__modal');
      if (modal) {
        modal.classList.add('active-modal');
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: modal }));
      }
    }
  
    function closeModal() {
      const modal = document.querySelector('.results-section__modal');
      if (modal) {
        modal.classList.remove('active-modal');
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      }
    }
  
    document.querySelector('.results-section__modal-button').addEventListener('click', () => {
      openModal();
    });
  
    document.querySelector('.results-section__modal').addEventListener('click', (e) => {
      if (e.target === document.querySelector('.results-section__modal')) {
        closeModal();
      }
    });
  
    document.querySelector('.results-section__modal__close').addEventListener('click', (e) => {
      closeModal();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
